/**
 * I-2479 PX-103: the database the unsent request's files are kept in (`clarityRunFiles.ts`), and its
 * deletion under the owner rule. Apart from the store itself so the owner rule (`ownerRule.ts`, in the
 * launch entry) carries a name and a delete, never the form's code.
 */
export const RUN_FILES_DB_NAME = 'featit-new-item-files';
/** As the local copy's own (`INDEXED_DB_OPEN_DEADLINE_MS`): a database that will not answer keeps nothing. */
export const RUN_FILES_OPEN_DEADLINE_MS = 3_000;

/** F-0534 PPD-2: the owner rule's dropper for this database (`OWNER_RULE_DATABASE_DROPPERS`). */
export function dropRunFilesDatabase(): Promise<void> {
  if (typeof window === 'undefined' || typeof window.indexedDB === 'undefined')
    return Promise.resolve();
  return new Promise((resolve) => {
    const deadline = setTimeout(resolve, RUN_FILES_OPEN_DEADLINE_MS);
    const done = () => {
      clearTimeout(deadline);
      resolve();
    };
    try {
      const request = window.indexedDB.deleteDatabase(RUN_FILES_DB_NAME);
      request.onsuccess = done;
      request.onerror = done;
      request.onblocked = done;
    } catch {
      done();
    }
  });
}
